import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, BACKEND_URL } from "./api";

const MediaCtx = createContext({ map: {}, slots: [], loading: true, refresh: () => {} });

export const resolveImage = (url) => {
  if (!url) return "";
  // Uploaded images are stored as "/api/uploads/{id}" — prefix with backend URL
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const MediaProvider = ({ children }) => {
  const [state, setState] = useState({ map: {}, slots: [], loading: true });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/media");
      const map = Object.fromEntries(Object.entries(data.map || {}).map(([k, v]) => [k, resolveImage(v)]));
      const slots = (data.slots || []).map(s => ({ ...s, url: resolveImage(s.url), raw: s.url }));
      setState({ map, slots, loading: false });
    } catch {
      setState(s => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <MediaCtx.Provider value={{ ...state, refresh }}>{children}</MediaCtx.Provider>;
};

export const useMedia = () => useContext(MediaCtx);

export const useImage = (key, fallback = "") => {
  const { map } = useMedia();
  return map[key] || fallback;
};
